import React from 'react';

function QuoteIcon(props) {
    return (
        <svg width={60} height={45} viewBox="0 0 60 45" aria-hidden focusable {...props}>
            <path
                d="M14.34 2.698A4 4 0 0118.123 0h7.521a4 4 0 013.883 4.962l-9.014 36.37a4 4 0 01-3.883 3.038H5.607c-2.747 0-4.676-2.705-3.783-5.302L14.34 2.698zM43.584 2.698A4 4 0 0147.367 0h7.521a4 4 0 013.883 4.962l-9.014 36.37a4 4 0 01-3.882 3.038H34.85c-2.747 0-4.676-2.705-3.782-5.302l12.515-36.37z"
            />
        </svg>
    );
}

export default QuoteIcon;
